import {
  CopilotActions,
  CopilotName,
  CopilotMessages,
  CopilotInput,
  CopilotSupportButton,
  useCopilotSessionContext,
} from '@/features/copilot';
import { close, useSidebarActive } from '@/features/sidebar';
import { useAnalytics } from '@/services/analytics';
import { Box, Button, Heading } from '@customerio/pluma-components/react';
import * as styles from './index.css';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

export default function Agent() {
  const isCopilotSidebarActive = useSidebarActive('copilot');
  const session = useCopilotSessionContext();
  const { track } = useAnalytics();

  useEffect(() => {
    if (isCopilotSidebarActive) {
      close();
    }
    // Only run once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Helmet>
        <title>Agent | Customer.io</title>
      </Helmet>
      <Box display="flex" flexDirection="column" h="full" w="full" backgroundColor="base">
        {/* Header */}
        <Box px="200" backgroundColor="base" className={styles.headerBar}>
          <Box display="flex" alignItems="center" justifyContent="space-between" py="100" className={styles.header}>
            <Heading level="4">
              <CopilotName />
            </Heading>
            <Box display="flex" alignItems="center" gap="100">
              <Button
                variant="subtle"
                size="sm"
                icon="add"
                onClick={() => {
                  session.reset();
                  track('aiAssistant', 'newChatClicked', {});
                }}
              >
                New agent
              </Button>
              <CopilotSupportButton />
              <CopilotActions />
            </Box>
          </Box>
        </Box>

        {/* Chat area */}
        <Box display="flex" flexDirection="column" flexGrow="1" h="0" w="full" className={styles.fullscreenChat}>
          <CopilotMessages />
          <Box className={`${styles.contentContainer} ${styles.inputCard}`}>
            <CopilotInput />
          </Box>
        </Box>
      </Box>
    </>
  );
}
